const text = `
# Timeline

The project is divided into two main phases, the first of these split into two sub-phases (1a and 1b). The first phase focuses on literature review of existing methods for the estimation of evapotranspiration from remote sensing data, followed by a selection of three models that will be tested in the prototyping phase (1b). After a review of model performance and implications for roll-out, the final model selection will be done at the CDR meeting with ESA. Af this, a 10-month implementation phase follows (2) where the selected method will be implemented and released.

![Project Timeline](/images/timeline.jpg 'Project Timeline')
`;

export default text;
